import { Link } from "react-router-dom";
import { ArrowRight, HardHat, Wrench, ClipboardList, Boxes, ShieldCheck, Ship } from "lucide-react";
import { useT } from "@/context/LangContext";

const KEYS = [
  { icon: HardHat, k: "construction" },
  { icon: Wrench, k: "renovation" },
  { icon: ClipboardList, k: "onestop" },
  { icon: Boxes, k: "sourcing" },
  { icon: ShieldCheck, k: "quality" },
  { icon: Ship, k: "logistics" },
];

export default function Services() {
  const t = useT();
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="services-page">
      <p className="kicker">{t("services.kicker")}</p>
      <h1 className="text-5xl lg:text-7xl font-display font-black tracking-tighter mt-4 max-w-4xl">{t("services.title")}</h1>
      <p className="text-[var(--ink-soft)] mt-6 max-w-2xl text-lg">{t("services.desc")}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
        {KEYS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={i} className="card-flat p-8" data-testid={`service-${i}`}>
              <Icon className="text-[var(--accent)]" size={26} />
              <h3 className="font-display text-xl font-bold mt-5">{t(`svc2.${s.k}.t`)}</h3>
              <p className="text-[var(--ink-soft)] mt-3 text-sm leading-relaxed">{t(`svc2.${s.k}.d`)}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-20 bg-[var(--ink)] text-white p-12 rounded-lg flex flex-col lg:flex-row items-center justify-between gap-8">
        <div>
          <h2 className="font-display text-3xl font-bold max-w-md">{t("services.cta.title")}</h2>
          <p className="text-white/60 mt-2">{t("services.cta.desc")}</p>
        </div>
        <Link to="/contact" className="btn-primary" data-testid="services-cta">
          {t("services.cta.btn")} <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
